import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const DeviceTabletSpeaker = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="deviceTabletSpeaker__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#deviceTabletSpeaker__a)">
          <path
            d="M12,1.5L4,1.5C3.602175,1.5,3.22064495,1.65803504,2.93934011,1.93934C2.65803504,2.22064495,2.5,2.602175,2.5,3L2.5,13C2.5,13.3978,2.65803504,13.77935,2.93934011,14.06065C3.22064495,14.34195,3.602175,14.5,4,14.5L12,14.5C12.3978004,14.5,12.77935,14.34195,13.06065,14.06065C13.34195,13.77935,13.5,13.3978,13.5,13L13.5,3C13.5,2.602175,13.34195,2.22064495,13.06065,1.93934C12.77935,1.65803504,12.3978004,1.5,12,1.5ZM10,4.5L6,4.5C5.8674002000000005,4.5,5.7402,4.4473199999999995,5.64645,4.353555200000001C5.5527,4.2597852,5.5,4.1326098,5.5,4C5.5,3.8673899,5.5527,3.7402151,5.64645,3.646445C5.7402,3.55268,5.8674002000000005,3.5,6,3.5L10,3.5C10.132599800000001,3.5,10.2598,3.55268,10.35355,3.646445C10.4473,3.7402151,10.5,3.8673899,10.5,4C10.5,4.1326098,10.4473,4.2597852,10.35355,4.353555200000001C10.2598,4.4473199999999995,10.132599800000001,4.5,10,4.5Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
